import { render, staticRenderFns } from "./ShopRouter_helpcenter_mobile.vue?vue&type=template&id=e8e0450e&scoped=true"
import script from "./ShopRouter_helpcenter_mobile.vue?vue&type=script&lang=js"
export * from "./ShopRouter_helpcenter_mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e0450e",
  null
  
)

export default component.exports